import '../../styles/interactives.scss'
import { useCallback, useEffect, useRef } from 'react'
const threshold = [0.65, 0.85]

export default function SocialCapital() {
  const paragraphs = useRef(null)
  const interactive = useRef(null)

  const handleSteps = useCallback(
    (entries) => {
      entries.forEach((entry) => {
        // check that we have a ref, and that we are measuring one way only
        if (!interactive?.current || entry?.boundingClientRect.y < 0) return
        const ratio = entry?.intersectionRatio ?? 0

        // On Mount the observer get called with a 0 value
        if (ratio === 0) return

        const paragraph = Number(entry?.target.getAttribute('data-index') ?? 0)
        if (paragraph === 0) return

        const beforeP1 = paragraph === 1 && ratio < threshold[0]
        const afterP1 = paragraph === 1 && ratio > threshold[1]

        const beforeP2 = paragraph === 2 && ratio < threshold[0]
        const afterP2 = paragraph === 2 && ratio > threshold[1]

        if (beforeP1) {
          interactive.current.removeAttribute('data-step')
        } else if (afterP1 || beforeP2) {
          interactive.current.setAttribute('data-step', 1)
        } else if (afterP2) {
          interactive.current.setAttribute('data-step', 2)
        }
      })
    },
    [interactive]
  )

  useEffect(() => {
    const observer = new IntersectionObserver(handleSteps, { threshold })

    if (paragraphs?.current) {
      paragraphs.current.querySelectorAll('li').forEach((paragraph, index) => {
        paragraph.setAttribute('data-index', index + 1)
        observer.observe(paragraph)
      })
    }

    return () => observer.disconnect()
  }, [handleSteps, paragraphs])

  return (
    <section className="interactive" name="Social Capital">
      <header>
        <h2>
          <strong>Social Capital</strong> Matters. Those who are getting first
          interviews are 100% or 2 times more likely to have done some
          networking
        </h2>
      </header>
      <main>
        <aside>
          <figure ref={interactive} className="social-capital">
            <p className="average">
              <strong>Average Network Use</strong>
              across whole sample
            </p>
            <ol>
              <li title="Black">
                <span>Black</span>
                <span>+28%</span>
              </li>
              <li title="South Asian">
                <span>South Asian</span>
                <span>+47%</span>
                <p>
                  <strong>More Likely</strong>
                  to have used their network
                </p>
              </li>
              <li title="Latino">
                <span>Latino</span>
                <span>-41%</span>
                <p>
                  <strong>Less Likely</strong>
                  to have used their network
                </p>
              </li>
            </ol>
          </figure>
        </aside>
        <ul ref={paragraphs}>
          <li>
            <p>
              <span>
                Early data shows differences in how young people are leveraging
                networks in their job&nbsp;search
              </span>
              The data reveals that race &amp; ethnicity play an outsized role
              in determining the size and contours of peoples&rsquo;
              professional networks
            </p>
          </li>
          <li>
            <p>
              Given this, universities need to invest resources to ensure all of
              their students <strong> mobilize their social capital</strong>
            </p>
          </li>
        </ul>
      </main>
    </section>
  )
}
